module.exports = __webpack_public_path__ + "static/media/home-heart.3aeba654.svg";